import * as z from "zod";

const MAX_RECIPIENT_IDS = 5000;

export const getSentEmailUrls = {
  name: "getSentEmailUrls" as const,
  input: z.object({
    recipientIds: z
      .array(z.string().regex(/^[0-9a-f]{24}$/i))
      .max(MAX_RECIPIENT_IDS),
  }),
  /** Recipients without a saved copy, or owned by another store, are absent. */
  output: z.object({
    emails: z.array(z.object({ recipientId: z.string(), url: z.string() })),
  }),
};
